export const GA_CLICK_ACTION = {
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  PAGINATION: 'PAGINATION',
  SHOW_PAGES: 'SHOW_PAGES'
}

const GA_KEY = {
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  PAGINATION: 'PAGINATION',
  SHOW_PAGES: 'SHOW_PAGES'
}

const GA_KEY_MAP = {
  [GA_KEY.EXPORT_EXCEL]: 'wh_exp_list_downloadfile',
  [GA_KEY.PAGINATION]: 'wh_exp_list_pages',
  [GA_KEY.SHOW_PAGES]: 'wh_exp_list_showpages'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.EXPORT_EXCEL:
    case GA_CLICK_ACTION.PAGINATION:
    case GA_CLICK_ACTION.SHOW_PAGES:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    category: 'warehouse',
    action: 'wh_expiringItems',
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
